import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Property } from 'src/typings';

@Component({
  selector: 'app-property-selector-item',
  templateUrl: './selector-item.component.html',
  styleUrls: ['./selector-item.component.scss']
})
export class SelectorItemComponent implements OnDestroy {
  constructor() {
    this.searchSubscription = this.searchControl.valueChanges.subscribe((value) => {
      if (!this.prop) return;
      this.filteredValues = this.prop?.values.filter((_value) => {
        return _value
          .replace(/[^\wа-яА-Я]|_/g, '')
          .toUpperCase()
          .includes(value.toUpperCase());
      });
      return;
    });
  }

  clear() {
    this.searchControl.setValue('');
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  searchSubscription: Subscription;

  searchControl: FormControl<string> = new FormControl();

  @Input() set prop(payload: { property: Property; values: string[] } | undefined) {
    this._prop = payload;
    if (payload) this.filteredValues = payload?.values;
  }

  @Input() set selectedProps(payload: { property: Property; values: string[] }[] | undefined) {
    this._selectedProps = payload;
    const findIndex = this.selectedProps?.findIndex((row) => {
      return row.property.id === this.prop?.property.id;
    });
    if (findIndex !== undefined && findIndex >= 0 && this.selectedProps !== undefined) {
      this.selectedProps[findIndex].values.forEach((value) => {
        if (!this.selectedProps) return;
        const findValue = this.selected.find((row) => row.value === value);
        if (!findValue) this.selected.push({ value });
      });
    }
  }

  get selectedProps() {
    return this._selectedProps;
  }

  private _selectedProps: { property: Property; values: string[] }[] | undefined;

  get prop() {
    return this._prop;
  }

  @Output() selectedChangesEvent: EventEmitter<{
    property: Property;
    values: string[];
  }> = new EventEmitter();

  private _prop: { property: Property; values: string[] } | undefined;

  filteredValues: string[] = [];

  selected: { value: string }[] = [];

  get selectedValues() {
    const find = this.selectedProps?.find(
      (__prop) => this.prop?.property.id === __prop.property.id
    );
    return find?.values;
  }

  toggle(value: string) {
    if (!this.prop) return;
    const find = this.checked(value);
    if (find > -1) {
      this.removeFromSelected(value);
    } else {
      this.addToSelected(value);
    }
    const res = {
      property: this.prop.property,
      values: this.selected.map((row) => row.value)
    };
    this.selectedChangesEvent.emit(res);
  }

  isChecked(value: string) {
    const findProp = this.selectedProps?.find((row) => row.property.id === this.prop?.property.id);
    if (findProp) {
      return findProp.values.includes(value);
    } else {
      return false;
    }
  }

  checked(value: string) {
    return this.selected.findIndex((selected_value) => {
      return selected_value.value == value;
    });
  }

  removeFromSelected(value: string) {
    const index = this.checked(value);
    return this.selected.splice(index, 1);
  }

  addToSelected(value: string) {
    this.selected.push({ value });
  }
}
